// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__Ikoms","rootSuccess":"CompleteLink_rootSuccess__2ECZp","rootFailure":"CompleteLink_rootFailure__NBf7N","isDisabled":"CompleteLink_isDisabled__1-xum"};